import { render, staticRenderFns } from "./allocateCenter.vue?vue&type=template&id=307afaa5&scoped=true"
import script from "./allocateCenter.vue?vue&type=script&lang=js"
export * from "./allocateCenter.vue?vue&type=script&lang=js"
import style0 from "./allocateCenter.vue?vue&type=style&index=0&id=307afaa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307afaa5",
  null
  
)

export default component.exports